<template>
	<v-container fluid>
		<v-row>
			<v-col
				cols="12"
				lg="4"
			>
				<v-card>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'UsersShow',
}
</script>

<style scoped>

</style>
